import React, { useEffect, useState } from 'react';
import './Styles.css';
import Modal from '../../../../../Elements/ids/Modal';
import TeamNode from './TeamNode';
import { ServiceClient } from '../../../../../Services/ServiceClient';
import { formatMessage } from '../../../../../Localization/formatMessage';
import Messages from '../../../../../Localization/Messages';
import { PresentationMode } from '../../../../../Enums/PresentationMode';
import { createServerErrorMessage } from '../../../../../Helpers/FormInputHelper';
import LoaderComponent from '../../../../../Elements/ids/Loader';
import ErrorMessage from '../../../../../Elements/ErrorMessage';

const TeamHierarchy = ({ team, closeView }) => {
  const [state, setState] = useState({});
  const [modalMode, setModalMode] = useState(PresentationMode.Loading);
  const [error, setError] = useState(null);

  useEffect(() => {
    ServiceClient.getTeamHierarchy(
      team.codePrefix,
      data => {
        setState(data);
        setModalMode(PresentationMode.View);
      },
      error => {
        setError(createServerErrorMessage(error).message);
      }
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Modal closeView={closeView} titleText={formatMessage(Messages.teamHierarchy_title)}>
      {modalMode === PresentationMode.Loading ? (
        <LoaderComponent />
      ) : modalMode === PresentationMode.Error ? (
        <ErrorMessage message={error} />
      ) : (
        <div className="teamPage-teamHierarchy-container">
          <ul className="teamPage-teamHierarchy-root">
            <TeamNode teamNode={state} currentTeam={team} />
          </ul>
        </div>
      )}
    </Modal>
  );
};

export default TeamHierarchy;
